module.exports = __webpack_public_path__ + "media/images/uscc_bg-587613f8f17d8b9d5f04803e0d971fad.png";